module.exports = __webpack_public_path__ + "img/ridg.3db49dd6.png";